import React, { useEffect, useState } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { animated, useSpring } from "react-spring";
import CloseIcon from "@material-ui/icons/Close";
import { slideUp, slideDown } from "../../styles/springs";
import CustomButton from "../Button/CustomButton";
import { tesaBlue, tesaWhite } from "../../styles/colors";
import probability from "../../api/services/common/probability";
import CookieService from "../../api/services/common/CookieService";
import { efsSurveyUrl } from "../../styles/urls";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      alignItems: "center",
      backgroundColor: tesaWhite,
      borderTop: `5px solid ${tesaBlue}`,
      bottom: "-208px",
      display: "flex",
      justifyContent: "center",
      left: 0,
      padding: theme.spacing(2.5),
      position: "fixed",
      width: "100vw",
      zIndex: 1200,
    },
    containerLeft: {
      marginRight: theme.spacing(4),
    },
    containerRight: {
      marginRight: theme.spacing(4),
      textAlign: "center",
    },
    closeIcon: {
      alignSelf: "flex-start",
      cursor: "pointer",
    },
    text: {
      maxWidth: "300px",
    },
    subtext: {
      fontSize: "0.6rem",
    },
  }),
);

const SurveySlideIn = () => {
  const cookieService = new CookieService();
  const classes = useStyles();
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 28);

  // open state used for triggering animation change
  const [open, setOpen] = useState(false);
  // show state used for controlling display value & preventing slide in from showing up by default
  const [show, setShow] = useState(true);
  // use state to set survey name when new surveys are available
  const [ueqID] = useState("tesa_leap_2021");

  useEffect(() => {
    if (cookieService.getCookie("UEQ-ID") !== ueqID) {
      setTimeout(() => {
        setOpen(probability(0.1));
      }, 3000);
    }
  }, []);

  // cascading effect for "show" state to allow smooth animations
  useEffect(() => {
    if (show !== open) {
      setShow(open);
    }
  }, [open]);

  const springProps = useSpring(show ? slideUp : slideDown);

  const handleClose = () => {
    cookieService.setCookie("UEQ-ID", ueqID, 28);
    setShow(false);
    setTimeout(() => setOpen(false), 2000);
  };

  const handleOpenSurvey = () => {
    window.open(efsSurveyUrl, "_newtab");
    handleClose();
    cookieService.setCookie("UEQ-ID", ueqID);
  };

  return (
    <animated.div className={classes.root} style={open ? springProps : undefined}>
      <div className={classes.containerLeft}>
        <h2>Your opinion is important to us!</h2>
        <p className={classes.text}>
          Please spend 2-3 minutes to help us improve LEAP. Thank you very much for your support.
        </p>
      </div>
      <div className={classes.containerRight}>
        <CustomButton primary text="Participate Now" onClick={handleOpenSurvey} />
        <p className={classes.subtext}>Survey will be opened in a new window</p>
      </div>
      <CloseIcon className={classes.closeIcon} onClick={handleClose} />
    </animated.div>
  );
};

export default SurveySlideIn;
